import React from 'react';
import { useTranslation } from 'react-i18next';
import SophisticatedTooltipContent from '@wix/da-shared-react/pkg/Popover/PopoverContent/SophisticatedTooltipContent';
import { useFirstTimeFlag } from '@wix/da-shared-react/pkg/redux/firstTimeFlags/hooks';
import { FirstTimeFlag } from '@wix/da-shared-react/pkg/redux/firstTimeFlags/constants';
import s from './DesktopWatchFTUE.scss';

export interface Props {
  className?: string;
}

const DesktopWatchFTUE: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const { dropFlag } = useFirstTimeFlag(FirstTimeFlag.IsDyw3RemoveNotSeen);

  return (
    <SophisticatedTooltipContent
      width={253}
      size="large"
      effectivePlacement="right"
      effectiveSecondaryPlacement="middle"
      heading={t('deviantsYouWatchPage.removeFtue.title')}
      description={t('deviantsYouWatchPage.removeFtue.text')}
      prefix={
        <img
          alt=""
          src="https://st.deviantart.net/eclipse/global/images/dyw3-remove-ftue.gif"
          className={s['illustration']}
        />
      }
      hasCloseButton
      onClose={dropFlag}
      className={className}
    />
  );
};
DesktopWatchFTUE.displayName = 'DesktopWatchFTUE';

export default DesktopWatchFTUE;
